import { format } from 'date-fns'
import clsx from 'clsx'

import { useGlobalState } from '@pepper/ui'
import { BUSINESS_PEPPER_ASSIGNMENT_STAGE } from '@pepper/utils/src/constant/enum/business_pepper_assignment_stage'
import { ASSIGNMENT_STATUS } from '@pepper/utils/src/constant/enum/assignment_status'

import styles from './_.module.css'

interface Props {
  platform: Platforms
}

function AssignmentMetadata({ platform }: Props) {
  const { assignmentDetails } = useGlobalState()

  const stageData = assignmentDetails?.status
    ? BUSINESS_PEPPER_ASSIGNMENT_STAGE[
        assignmentDetails.status as keyof typeof BUSINESS_PEPPER_ASSIGNMENT_STAGE
      ]
    : null

  if (!assignmentDetails) return null

  switch (platform) {
    case 'business':
      if (stageData) {
        return (
          <p className={styles.item}>
            <span>Status:</span>
            <span
              className={clsx('pill', styles.pill, styles[stageData.color])}
            >
              {stageData.title}
            </span>
          </p>
        )
      }
      return null

    case 'creators':
      return (
        <>
          <p className={styles.item}>
            <span>Status:</span>
            <span className={clsx('pill', styles.pill, styles.gold)}>
              {ASSIGNMENT_STATUS[assignmentDetails.status].title}
            </span>
          </p>
          {assignmentDetails.deadline && (
            <p className={styles.item}>
              <span>Deadline:</span>
              <span className={clsx('pill', styles.pill, styles.blue)}>
                {format(new Date(assignmentDetails.deadline), 'HH:mm, do MMM')}
              </span>
            </p>
          )}
        </>
      )

    default:
      return null
  }
}

export default AssignmentMetadata
